export const HHMMRegex = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])$/;

// 時間文字列を分単位に変換する関数
export const timeStringToMinutes = (timeString) => {
  if (!timeString) return null;

  const [hours, minutes] = timeString.split(":").map(Number);
  return hours * 60 + minutes;
};

// 現在時刻を分単位で取得する関数
export const getCurrentTimeInMinutes = () => {
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes();
};
